module.exports = __webpack_public_path__ + "img/academy-without-screen.2521d73.png";